module.exports = __webpack_public_path__ + "img/pic1.dec562c5.jpg";